<template>
  <div>
    <VueJsonPretty
      class="debug-json-viewer"
      :data="data"
      :showLine="false"
      :showIcon="true"
      :showLineNumber="false"
      :showLength="true"
      :deep="depth"
      :showDoubleQuotes="false"
    >
      <template v-if="$slots.renderNodeValue" #renderNodeValue="{ node, defaultValue }">
        <slot name="renderNodeValue" :node="node" :defaultValue="defaultValue" />
      </template>
    </VueJsonPretty>
  </div>
</template>

<script lang="ts" src="./dl-jsonviewer"></script>

<style lang="scss" scoped>
@use './dl-jsonviewer.scss';
</style>
